import type {
  WebsiteAdFieldsFragment,
  VideoAdFieldsFragment,
  LeadAdFieldsFragment,
} from './auction-ads.gql-types';

export enum SiteSections {
  DiscoUpdates = 'disco-updates',
  SupiNetworkHome = 'supi-network-home',
  JobsRecommendation = 'jobs-recommendation',
  JobsRecommendationMyJobs = 'jobs-recommendation-my-jobs',
  JobsJobList = 'jobs-job-list',
  JobsInline = 'jobs-inline',
  JobsSearch = 'jobs-search',
  Birthdays = 'birthdays',
  Profile = 'profile',
  Logout = 'logout',
  NotificationCenter = 'notification-center',
  Search = 'search',
}

export type AdFields =
  | WebsiteAdFieldsFragment
  | VideoAdFieldsFragment
  | LeadAdFieldsFragment;

export type AdsContext = {
  isCompleted: boolean;
  ads: AdFields[];
};
